// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._1bsb1tcg{width:24px}\n._1bsb7vkz{width:1pc}\n._1bsbckbl{width:3pc}\n._1bsbzwfg{width:2pc}\n._1reo15vq{overflow-x:hidden}\n._4t3i1tcg{height:24px}\n._4t3i7vkz{height:1pc}\n._4t3ickbl{height:3pc}\n._4t3izwfg{height:2pc}\n._lcxvglyw{pointer-events:none}\n._lswuvuon{fill:var(--ds-surface,#fff)}\n._vc881r31 stop{stop-color:currentColor}", ""]);
// Exports
module.exports = exports;
